/* eslint-disable jira/filename-case */
type CompareFn = <T>(a: T, b: T) => boolean;

const hasOwnProp = Object.prototype.hasOwnProperty;

/**
 * Compare two objects in a shallow manner: comparing own property values.
 *
 * @param {T} a
 * @param {T} b
 * @param {Function} [compare=Object.is]
 * @returns {boolean}
 */
export const isShallowEqual = <T,>(a: T, b: T, compare: CompareFn = Object.is): boolean => {
	if (compare(a, b)) {
		return true;
	}

	if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
		return false;
	}

	const keysA = Object.keys(a);
	const keysB = Object.keys(b);

	if (keysA.length !== keysB.length) {
		return false;
	}

	let i = keysA.length;
	while (i--) {
		const key = keysA[i];
		// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
		if (!hasOwnProp.call(b, key) || !compare(a[key], b[key])) {
			return false;
		}
	}

	return true;
};
